import { useEffect } from 'react';
import { Template } from '.';
import { validateAndNotifyTemplateDuplicates } from '../utils';

export const useValidateAndNotifyTemplateDuplicates = (templates: Template[]): void => {
  useEffect(() => {
    if (templates?.length > 0) {
      validateAndNotifyTemplateDuplicates(templates);
    }
  }, [templates]);
};
